"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ProducerPlayer", {
  enumerable: true,
  get: function get() {
    return _Player["default"];
  }
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _props = require("./props");
var _utils = require("./utils");
var _YouTube = _interopRequireDefault(require("./players/YouTube"));
var _SoundCloud = _interopRequireDefault(require("./players/SoundCloud"));
var _Vimeo = _interopRequireDefault(require("./players/Vimeo"));
var _Facebook = _interopRequireDefault(require("./players/Facebook"));
var _FilePlayer = _interopRequireDefault(require("./players/FilePlayer"));
var _Streamable = _interopRequireDefault(require("./players/Streamable"));
var _Vidme = _interopRequireDefault(require("./players/Vidme"));
var _Wistia = _interopRequireDefault(require("./players/Wistia"));
var _DailyMotion = _interopRequireDefault(require("./players/DailyMotion"));
var _Twitch = _interopRequireDefault(require("./players/Twitch"));
var _domOnlyProps = _interopRequireDefault(require("cccisd-redux-form-helpers/dist/helpers/domOnlyProps.js"));
var _Producer = _interopRequireDefault(require("./players/Producer"));
var _Player = _interopRequireDefault(require("./players/Producer/Player.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : String(i); }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var SUPPORTED_PROPS = Object.keys(_props.propTypes);
var SUPPORTED_PLAYERS = [_YouTube["default"], _SoundCloud["default"], _Vimeo["default"], _Facebook["default"], _Streamable["default"], _Vidme["default"], _Wistia["default"], _Twitch["default"], _DailyMotion["default"], _Producer["default"]];
var ReactPlayer = exports["default"] = /*#__PURE__*/function (_Component) {
  _inherits(ReactPlayer, _Component);
  function ReactPlayer() {
    var _this;
    _classCallCheck(this, ReactPlayer);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _callSuper(this, ReactPlayer, [].concat(args));
    _defineProperty(_assertThisInitialized(_this), "config", (0, _utils.getConfig)(_this.props, _props.defaultProps, true));
    _defineProperty(_assertThisInitialized(_this), "seekTo", function (fraction) {
      if (!_this.player) return null;
      _this.player.seekTo(fraction);
    });
    _defineProperty(_assertThisInitialized(_this), "getDuration", function () {
      if (!_this.player) return null;
      return _this.player.getDuration();
    });
    _defineProperty(_assertThisInitialized(_this), "getCurrentTime", function () {
      if (!_this.player) return null;
      return _this.player.getCurrentTime();
    });
    _defineProperty(_assertThisInitialized(_this), "getInternalPlayer", function () {
      if (!_this.player) return null;
      return _this.player.player;
    });
    _defineProperty(_assertThisInitialized(_this), "play", function () {
      if (!_this.player) return null;
      _this.player.player.play();
    });
    _defineProperty(_assertThisInitialized(_this), "pause", function () {
      if (!_this.player) return null;
      _this.player.player.pause();
    });
    _defineProperty(_assertThisInitialized(_this), "progress", function () {
      if (_this.props.url && _this.player && _this.player.isReady) {
        var playedSeconds = _this.player.getCurrentTime() || 0;
        var loadedSeconds = _this.player.getSecondsLoaded();
        var duration = _this.player.getDuration();
        if (duration) {
          var progress = {
            playedSeconds: playedSeconds,
            played: 100 * Math.min(1, playedSeconds / duration)
          };
          if (loadedSeconds !== null) {
            progress.loadedSeconds = loadedSeconds;
            progress.loaded = loadedSeconds / duration;
          }
          // Only call onProgress if values have changed
          if (progress.played !== _this.prevPlayed || progress.loaded !== _this.prevLoaded) {
            _this.props.onProgress(progress);
          }
          _this.prevPlayed = progress.played;
          _this.prevLoaded = progress.loaded;
        }
      }
      _this.progressTimeout = setTimeout(_this.progress, _this.props.progressFrequency);
    });
    _defineProperty(_assertThisInitialized(_this), "renderPlayer", function (Player) {
      return /*#__PURE__*/_react["default"].createElement(Player, _extends({}, _this.props, {
        ref: _this.activePlayerRef,
        key: Player.displayName,
        config: _this.config
      }));
    });
    _defineProperty(_assertThisInitialized(_this), "activePlayerRef", function (player) {
      _this.player = player;
    });
    _defineProperty(_assertThisInitialized(_this), "wrapperRef", function (wrapper) {
      _this.wrapper = wrapper;
    });
    _defineProperty(_assertThisInitialized(_this), "renderPreloadPlayer", function (Player) {
      return /*#__PURE__*/_react["default"].createElement(Player, {
        key: Player.displayName,
        config: _this.config
      });
    });
    return _this;
  }
  _createClass(ReactPlayer, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.progress();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.progressTimeout);
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      return this.props.url !== nextProps.url || this.props.playing !== nextProps.playing || this.props.controls !== nextProps.controls || this.props.volume !== nextProps.volume || this.props.muted !== nextProps.muted || this.props.playbackRate !== nextProps.playbackRate || this.props.height !== nextProps.height || this.props.width !== nextProps.width || this.props.hidden !== nextProps.hidden;
    }
  }, {
    key: "renderActivePlayer",
    value: function renderActivePlayer(url) {
      if (!url) return null;
      var Player = SUPPORTED_PLAYERS.find(function (player) {
        return player.canPlay(url);
      });
      if (Player !== undefined) {
        return this.renderPlayer(Player);
      }
      return this.renderPlayer(_FilePlayer["default"]);
    }
  }, {
    key: "renderPreloadPlayers",
    value: function renderPreloadPlayers(url) {
      // Render additional players if preload config is set
      var preloadPlayers = [];
      if (!_YouTube["default"].canPlay(url) && this.config.youtube.preload) {
        preloadPlayers.push(_YouTube["default"]);
      }
      if (!_Vimeo["default"].canPlay(url) && this.config.vimeo.preload) {
        preloadPlayers.push(_Vimeo["default"]);
      }
      if (!_DailyMotion["default"].canPlay(url) && this.config.dailymotion.preload) {
        preloadPlayers.push(_DailyMotion["default"]);
      }
      return preloadPlayers.map(this.renderPreloadPlayer);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
        url = _this$props.url,
        style = _this$props.style,
        width = _this$props.width,
        height = _this$props.height;
      var otherProps = (0, _utils.omit)(this.props, SUPPORTED_PROPS, _props.DEPRECATED_CONFIG_PROPS);
      var activePlayer = this.renderActivePlayer(url);
      var preloadPlayers = this.renderPreloadPlayers(url);
      return /*#__PURE__*/_react["default"].createElement("div", _extends({
        ref: this.wrapperRef,
        style: _objectSpread(_objectSpread({}, style), {}, {
          width: width,
          height: height
        })
      }, (0, _domOnlyProps["default"])(otherProps)), activePlayer, preloadPlayers);
    }
  }]);
  return ReactPlayer;
}(_react.Component);
_defineProperty(ReactPlayer, "displayName", 'ReactPlayer');
_defineProperty(ReactPlayer, "propTypes", _props.propTypes);
_defineProperty(ReactPlayer, "defaultProps", _props.defaultProps);
_defineProperty(ReactPlayer, "canPlay", function (url) {
  var players = [].concat(SUPPORTED_PLAYERS, [_FilePlayer["default"]]);
  return players.some(function (player) {
    return player.canPlay(url);
  });
});